import React, { PureComponent } from "react";
import { Input, Radio, Message, Button, Layout } from "element-react";
import { Link } from "react-router-dom";
// import { Scrollbars } from 'react-custom-scrollbars';

import Request from "../../networkReq/request";
import Http from "../../networkReq/http";
import Navigation from "../../components/navigation";
import { getToken, getCurrentUser } from 'utils/storage';
import "./index.scss";

export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hotquestions: [],
      data: [
        { id: 1, name: '办事查询', url: '/entrance/workservice' },
        { id: 2, name: '投诉建议', url: 'https://zwfw.nmg.gov.cn/sso//sso/login?utype=0&redirect=istrue&client_id=BI3LH75LM&goto=/complaint?regionCode=150000' },
        { id: 3, name: '用户指引', url: "../../tyjrmh/download/内蒙古退役军人门户系统操作说明.pdf" }
      ],
      questions: [{ id: 1, name: '退役军人' }, { id: 2, name: '登录问题' }, { id: 3, name: '退役军人' }, { id: 4, name: '登录问题' }, { id: 5, name: '退役军人' }, { id: 6, name: '退役军人' }, { id: 7, name: '登录问题' }, { id: 8, name: '退役军人' }, { id: 9, name: '登录问题' }, { id: 10, name: '退役军人' }, { id: 11, name: '登录问题' }, { id: 12, name: '退役军人' }],
      sendcontent: '',
      sendlist: [],
    };
  }

  componentDidMount() {
    const user = getCurrentUser();
    const token = getToken();
    this.setState({
      userdata: user,
      token: token
    })
    Http.get(Request.getProblems(), {current: 1,size: 12,id: '1430080783830552578'}, obj => {
      if (obj.code == 200) {
        this.setState({
          questions: obj.data.records,
        })
      }
    });
    Http.get(Request.getProblems(), {current: 1,size: 10,id: '1430080715253682177'}, obj => {
      if (obj.code == 200) {
        this.setState({
          hotquestions: obj.data.records,
        })
      }
    });
  }

  handleComplanit = (url) => {
    window.open(url);
  }

  onChange(key, value){
    if (key == 'content') {
      this.setState({
        sendcontent: value
      })
    }
  }

  shouldComponentUpdate(){
    if(this.state.sendlist){
      return true
    }
    return false
  }

  handSelect(item) {
    let arr = this.state.sendlist;
    let that = this;
    arr.push({ issend: 1, content: item.problem });
    that.setState({
      sendlist: arr,
    })
    setTimeout(function () {
      Http.get(Request.getAnswer(), {problemId: item.id,current: 1,size: 1,isDeleted: 0}, obj => {
        if (obj.code == 200) {
          if (obj.data.records.length > 0) {
            obj.data.records.map(function (r, i) {
              arr.push({ issend: 0, content: r.answer })
            })
          } else {
            arr.push({ issend: 0, content: '您的问题太难了，我暂时还不会呢~' })
          }
          that.setState({
            sendlist: arr,
          })
        }
      });
    }, 200)
  }

  fetchclass = (params) => {
    let arr = this.state.sendlist;
    Http.get(Request.getAnswerClass(), params, obj => {
      if (obj.code == 200) {
        if (obj.data.classificationList.length == 0 && obj.data.problemList.length == 0) {
          arr.push({ issend: 0, content: obj.data.msg });
        } else {
          arr.push({ issend: 0, isfl: true, calssdata: obj.data.classificationList,questions: obj.data.problemList });
        }
        this.setState({
          sendlist: arr,
        })
      }
    });
  }

  handClassSelect(item) {
    let arr = this.state.sendlist;
    let that = this;
    arr.push({ issend: 1, content: item.folderName });
    this.setState({
      sendlist: arr,
    })
    setTimeout(function () {
      that.fetchclass({ id: item.id });
    }, 200)
  }

  handSend = () => {
    const { sendcontent } = this.state;
    let arr = this.state.sendlist;
    let that = this;
    if (sendcontent == '') {
      Message({
        message: '请输入您要咨询的问题！',
        type: 'warning'
      });
      return;
    }
    arr.push({issend: 1,content: sendcontent});
    this.setState({
      sendlist: arr,
      sendcontent: ''
    });
    setTimeout(function () {
      Http.get(Request.getInputAnswer(), {problem: sendcontent}, obj => {
        if (obj.code == 200) {
          if (Object.keys(obj.data).length > 0) {
            if (obj.data.type == 3) {
              // that.fetchclass({ id: obj.data.id });
              arr.push({ issend: 0, isfl: true, calssdata: obj.data.data,questions:[] });
            } else if (obj.data.type == 2) {
              arr.push({ issend: 0,iswt: true,questions: obj.data.data })
            } else {
              arr.push({ issend: 0, content: obj.data.data })
            }
          } else {
            arr.push({ issend: 0, content: '您的问题太难了，我暂时还不会呢~' })
          }
          that.setState({
            sendlist: arr,
          })
        }
      });
    }, 200)
  }

  render() {
    const { data, userdata, token, questions, sendlist, hotquestions } = this.state;
    console.log('sendlist111',sendlist)
    return (
      <div className="customService">
        {/* <Navigation /> */}
        <div className="custom">
          <div className="customTitle">智能问答</div>
          <Layout.Row>
            <Layout.Col span="16">
              <div className="customLeft">
                {/* <Scrollbars style={{ minHeight: 534 }} > */}
                <div className="dialogContainer">
                  <div className="answers">
                    <div className="answersContainer">
                      <div>您好！智能机器人正在为您服务，把你想要咨询的问题告诉我</div>
                      <div style={{color: '#C3C3C3',padding: '10px 0'}}>猜你想问...</div>
                      <div className="answersClass">
                        {questions && questions.length > 0 && questions.map((item, i) => {
                          return (
                            <div className="answerChild" onClick={() => this.handSelect(item)}>{item.problem}</div>
                          )
                        })}
                      </div>
                    </div>
                  </div>
                  {sendlist && sendlist.length > 0 && sendlist.map((r, i) => {
                    if (r.issend == 1) {
                      return (
                        <div key={i} className="questionsContainer">
                          <span className="questionChild">{r.content}</span>
                        </div>
                      )
                    } else {
                      if (r && r.isfl) {
                        return (
                          <div key={i} className="answers">
                            <div className="answersContainer">
                              {r.calssdata && r.calssdata.length > 0 && <>
                                <div style={{paddingBottom: 10}}>您的问题属于以下哪个情况呢（您也可以不选择，继续直接提问哦）</div>
                                <div className="answersClass">
                                  {r.calssdata.map((rr, i) => {
                                    return (
                                      <div className="answerChild" onClick={() => this.handClassSelect(rr)}>{rr.folderName}</div>
                                    )
                                  })}
                                </div>
                              </>}
                              {r.calssdata && r.questions && r.calssdata.length > 0 && r.questions.length > 0 &&
                                <div className="answerline"></div>}
                              {r.questions && r.questions.length>0 && <>
                                <div style={{ paddingBottom: 10 }}>{r.calssdata.length==0?'猜你想问...':'其他相关问题'}</div>
                                <div className="answersClass">
                                  {r.questions.map((rr, i) => {
                                    return (
                                      <div className="answerChild" onClick={() => this.handSelect(rr)}>{rr.problem}</div>
                                    )
                                  })}
                                </div>
                              </>}
                            </div>
                          </div>
                        )
                      } else if (r && r.iswt) {
                        return (
                          <div key={i} className="answers">
                            <div className="answersContainer">
                              <div style={{paddingBottom: 10}}>您的问题属于以下哪个情况呢（您也可以不选择，继续直接提问哦）</div>
                              <div className="answersClass">
                                {r.questions && r.questions.length > 0 && r.questions.map((rr, i) => {
                                  return (
                                    <div className="answerChild" onClick={() => this.handSelect(rr)}>{rr.problem}</div>
                                  )
                                })}
                              </div>
                            </div>
                          </div>
                        )
                      } else {
                        return (
                          <div key={i} className="answers">
                            <div className="answersContainer" style={{padding: 16}}>{r.content}</div>
                          </div>
                        )
                      }
                    }
                  })}
                </div>
                <div className="sendContainer">
                  <div className="textarea">
                    <Input
                      type="textarea"
                      value={this.state.sendcontent}
                      autosize={{ minRows: 4, maxRows: 10}}
                      placeholder="请输入您想咨询的问题..."
                      onChange={this.onChange.bind(this, 'content')}
                    />
                  </div>
                  <Button type="primary" onClick={() => this.handSend()}>发送</Button>
                </div>
                {/* </Scrollbars> */}
              </div>
            </Layout.Col>
            <Layout.Col span="8">
              <div className="customRight">
                <div className="rightTitle"><div className="titlesign"></div>热点问题</div>
                <ul className="classContainer">
                  {hotquestions && hotquestions.length > 0 && hotquestions.map((item, i) => {
                    return (
                      <li className="class" onClick={() => this.handSelect(item)}>
                        <div className="icon-disc"></div>
                        <div>{item.problem}</div>
                      </li>
                    )
                  })}
                </ul>
                <div className="rightTitle"><div className="titlesign"></div>常用工具</div>
                <div className="tools">
                {data && data.length > 0 && data.map((item, i) => {
                  if (item.id == 3) {
                    return (
                      <a key={i} href={ item.url } >
                        <div key={i} className="tools-children" >
                          <div className="tools-img">
                            {/* <img src={item.defaultimg} /> */}
                          </div>
                          <div style={{ marginTop: 10 }}>{item.name}</div>
                        </div>
                      </a>
                    )
                  } else if(item.id == 2) {
                    return (
                      <Link key={i} to={{ pathname: '' }} onClick={() => this.handleComplanit(item.url)}>
                        <div key={i} className="tools-children" >
                          <div className="tools-img">
                            {/* <img src={item.defaultimg} /> */}
                          </div>
                          <div style={{ marginTop: 10 }}>{item.name}</div>
                        </div>
                      </Link>
                    )
                  } else {
                    return (
                      <Link key={i} to={{ pathname: item.url }}>
                        <div key={i} className="tools-children" >
                          <div className="tools-img">
                            {/* <img src={item.defaultimg} /> */}
                          </div>
                          <div style={{ marginTop: 10 }}>{item.name}</div>
                        </div>
                      </Link>
                    )
                  }
                })}
                </div>
              </div>
            </Layout.Col>
          </Layout.Row>
        </div>
      </div>
    );
  }
}
